<div class="w-[70vw]">
  <h2 mat-dialog-title class="flex items-center mt-3">
    {{ message('exportHeader') }}
    <span class="ml-auto material-icons cursor-pointer hover:opacity-80" (click)="close()">close</span>
  </h2>
  <mat-dialog-content>
    <label class="sr-only" for="exportTextBox">Import Text Box</label>
    <textarea #exportBox id="exportTextBox" class="w-full h-[50vh] mt-2 form-control" readonly
              [value]="exportJson()" (click)="selectAllText(exportBox)"></textarea>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button [cdkCopyToClipboard]="exportBox.value"
            (click)="onCopy()">{{ message('copyClipboardButton') }}
    </button>
  </mat-dialog-actions>
</div>
